import React from 'react';
import PropTypes from "prop-types";
import intl from "react-intl-universal";
import Modal from '../../Common/Modal';
import Address from '../../Address';
import styles from './index.module.scss';
import {Commun} from "../../../utils/axios";
import common from "../../../common/common";

class AddressModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '', // 收货人姓名
            phone: '', // 收货人联系方式
            address: '' // 收货人地址
        }
    }

    static defaultProps = {
        visible: false,
        onSuccess: null,
        onCancel: null
    };

    static propTypes = {
        visible: PropTypes.bool, // 是否展示
        onSuccess: PropTypes.func, // 保存成功后的回调
        onCancel: PropTypes.func // 点击取消按钮后的回调
    };

    componentDidMount() {
        this.getUserInfo();
    }

    // 获取用户信息
    getUserInfo = () => {
        Commun.get(`${common.userApiPrefix}/address`).then(res => {
            const { consignee = '', phone = '', address = '' } = res[res.length - 1] || {};
            this.setState({
                name: consignee,
                phone,
                address
            })
        }).catch(error => {
            console.log(error);
        });
    };

    onCancel = () => {
        typeof this.props.onCancel === 'function' && this.props.onCancel();
    };

    onSuccess = () => {
        typeof this.props.onSuccess === 'function' && this.props.onSuccess();
    };


    render() {
        const { visible} = this.props;

        const { name, phone, address } = this.state;

        return (
            <Modal
                visible={visible}
                width={380}
                maskStyle={{
                    zIndex: 10001
                }}
                title={
                    <div className={styles.title}>{intl.get('GOODS_RECEIVE_INFO')}</div>
                }
                closable={false}
                footer={null}
                onCancel={this.onCancel}
            >
                <Address
                    name={name}
                    phone={phone}
                    address={address}
                    showCancelBtn={false}
                    onSuccess={this.onSuccess}
                    onCancel={this.onCancel}
                />
            </Modal>
        )
    }
}
export default AddressModal;